import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { useApp } from "../context/AppContext";
import { forgotPassword } from "../services/api";
import Seo from "../components/Seo";
import { KeyRound, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const { t, lang } = useApp();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch { setSent(true); }
    setLoading(false);
  };

  return (
    <div className="pt-20 min-h-screen bg-cream flex items-start justify-center">
      <Seo title={t("auth.forgotTitle")} description={t("auth.forgotSub")} path="/forgot-password" lang={lang} noindex />
      <div className="w-full max-w-md mx-auto px-6 py-16" data-testid="forgot-password-page">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto rounded-full bg-wine flex items-center justify-center mb-4"><KeyRound className="w-6 h-6 text-gold" /></div>
          <h1 className="font-serif text-3xl text-ink">{t("auth.forgotTitle")}</h1>
          <p className="text-ink/60 mt-2">{t("auth.forgotSub")}</p>
        </div>
        {sent ? (
          <div className="bg-green-50 border border-green-200 rounded-2xl p-6 text-center" data-testid="forgot-success">
            <MailCheck className="w-8 h-8 mx-auto text-green-600 mb-3" />
            <p className="text-green-800 text-sm">{t("auth.forgotSent")}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("auth.email")} required className="bg-white h-12" />
            <Button data-testid="forgot-submit-button" type="submit" disabled={loading} className="w-full bg-wine hover:bg-wine-dark text-white h-12 text-base">
              {loading ? "…" : t("auth.sendResetLink")}
            </Button>
          </form>
        )}
        <p className="text-center text-sm text-ink/50 mt-8">
          <Link to="/login" className="hover:text-wine underline underline-offset-4">{t("auth.backToLogin")}</Link>
        </p>
      </div>
    </div>
  );
}
